module.exports = __webpack_public_path__ + "themify.a1ecc3b826d01251eddd.woff";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/node_modules/ti-icons/fonts/themify.woff
// module id = ../../../../ti-icons/fonts/themify.woff
// module chunks = styles